import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  SideNavigation,
  SideNavigationItem,
} from '../../components/SideNavigation';

interface SiteMenuProps {
  showSync?: boolean;
}

const SiteMenu = React.memo(({ showSync = false }: SiteMenuProps) => (
  <SideNavigation>
    <SideNavigationItem isDefault to="">
      <FormattedMessage id="site.menu.settings" defaultMessage="Settings" />
    </SideNavigationItem>
    <SideNavigationItem to="finds">
      <FormattedMessage id="site.menu.finds" defaultMessage="Finds" />
    </SideNavigationItem>
    <SideNavigationItem to="images">
      <FormattedMessage id="site.menu.images" defaultMessage="Images" />
    </SideNavigationItem>
    <SideNavigationItem to="objects">
      <FormattedMessage id="site.menu.objects" defaultMessage="Objects" />
    </SideNavigationItem>
    <SideNavigationItem to="access">
      <FormattedMessage id="site.menu.access" defaultMessage="Access" />
    </SideNavigationItem>
    {showSync && (
      <SideNavigationItem to="sync">
        <FormattedMessage id="site.menu.sync" defaultMessage="Sync" />
      </SideNavigationItem>
    )}
    <SideNavigationItem to="pas">
      <FormattedMessage id="site.menu.pas" defaultMessage="PAS" />
    </SideNavigationItem>
  </SideNavigation>
));

export { SiteMenu };
